import React from 'react'
import { CrudPageContent } from '@morningtrain/react-crud'
import * as Columns from 'support/columns'
import * as Filters from 'support/filters'
import SmartIndexLayout from 'layouts/crud/SmartIndexLayout'
import ViewCustomerSmartview
  from 'widgets/smartviews/customers/ViewCustomerSmartview'
import Delete from 'support/actions/Delete'
import Restore from 'support/actions/Restore'

export default class Index extends CrudPageContent {
  get resourceName () {
    return 'customers'
  }

  get layout () {
    return SmartIndexLayout
  }

  get filters () {
    return (
      <>
        <Filters.SearchFilter />
        <Filters.EnumFilter name='trashed' enum='trash_types' />
      </>
    )
  }

  get columns () {
    return (
      <>
        <Columns.Text name='customer_number' label='Kundenr' />
        <Columns.Text name='name' label='Virksomhedsnavn' />
        <Columns.Text name='email' />
        <Columns.Text name='contact.name' label='Kontaktperson' />
        <Columns.Text name='cvr' />
      </>
    )
  }

  get actions () {
    return (
      <>
        <Delete />
        <Restore />
      </>
    )
  }

  renderAfterCrud () {
    return null
  }

  get crudProps () {
    return {
      ...super.crudProps,
      createLabel: 'Opret kunde',
      smartview: <ViewCustomerSmartview />
    }
  }
}
